import { TransformInt } from '../../../decorators/transform-int.decorator';
import { FileDto } from '../../files/dtos/file.dto';
import { FeatureItemValueTypeEnum } from '../enums/feature-item-value-type.enum';

/**
 * Base feature item DTO
 */
export abstract class BaseFeatureItemDto {
  @TransformInt()
  id?: number;
  uuid!: string;
  key!: string;
  title!: string;
  subTitle?: string | null;
  description?: string | null;
  value?: string | number | boolean | null;
  valueType?: FeatureItemValueTypeEnum | null;
  files?: FileDto[] | null;
  isVisible?: boolean | null;
}
